import type { DocPageContent } from '../docs-content'

const page = {
  order: 8,
  slug: 'preview',
  title: 'Vista previa y reproducción',
  description:
    'Reproduce, avanza fotograma a fotograma, haz zoom en el monitor, pasa a pantalla completa, guarda fotogramas y usa la reproducción con proxy.',
  category: 'Edición principal',
  related: ['timeline', 'effects-color'],
  sections: [
    {
      title: 'Reproducir y navegar',
      blocks: [
        {
          kind: 'list',
          items: [
            'Reproduce y pausa con los controles de vista previa o con `Espacio`.',
            'Avanza un fotograma a la vez con `Izquierda` y `Derecha` para verificaciones precisas.',
            'Salta al inicio de la línea de tiempo con `Inicio` y al final con `Fin`.',
            'Consulta el código de tiempo para confirmar la posición exacta del cursor de reproducción.',
          ],
        },
      ],
    },
    {
      title: 'Encuadrar la vista',
      blocks: [
        {
          kind: 'list',
          items: [
            'Ajusta el zoom de la vista previa para inspeccionar el detalle; esto no cambia el lienzo de exportación.',
            'Usa **Pantalla completa** al revisar el movimiento o el encuadre, y Salir de pantalla completa para volver.',
            'Usa **Guardar fotograma** para escribir el fotograma actual en un archivo de imagen.',
            'Las superposiciones de transformación, máscara y edición aparecen en el monitor cuando hay un elemento correspondiente seleccionado.',
          ],
        },
      ],
    },
    {
      title: 'Rendimiento de reproducción y audio',
      blocks: [
        {
          kind: 'list',
          items: [
            'Cuando existen proxies, CachoCut los usa para una reproducción más fluida de medios pesados; las exportaciones siguen usando los originales.',
            'El control de volumen del monitor afecta solo a la reproducción local.',
          ],
        },
        {
          kind: 'note',
          tone: 'info',
          text: 'Las exportaciones usan la mezcla del proyecto, por lo que el volumen del monitor nunca cambia el audio renderizado.',
        },
      ],
    },
  ],
} satisfies DocPageContent

export default page
